import React, { useEffect, useState, Fragment } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ArrowRightIcon, ShieldCheckIcon, ZapIcon, LockIcon, CreditCardIcon } from 'lucide-react';
function useCountdown(initialMinutes: number) {
  const [s, setS] = useState(initialMinutes * 60);
  useEffect(() => {
    const t = setInterval(() => setS(v => v > 0 ? v - 1 : 0), 1000);
    return () => clearInterval(t);
  }, []);
  return {
    h: String(Math.floor(s / 3600)).padStart(2, '0'),
    m: String(Math.floor(s % 3600 / 60)).padStart(2, '0'),
    sec: String(s % 60).padStart(2, '0')
  };
}
const includes = ['Ebook completo (6 módulos)', 'Bonus 1: 50 frases para responder sin pelear', 'Bonus 2: Detectar manipuladores rápidamente', 'Bonus 3: Manejar jefes difíciles', 'Bonus 4: Dejar de absorber problemas ajenos', 'Bonus Premium: Personalidades difíciles explicadas', 'Acceso de por vida', 'Acceso desde cualquier dispositivo'];
export function OfferSection() {
  const {
    h,
    m,
    sec
  } = useCountdown(14);
  return <section id="oferta" className="w-full py-20 md:py-28 px-4" data-id="element-240">
      <div className="max-w-3xl mx-auto" data-id="element-241">
        {/* Countdown bar */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-242">
          <div className="inline-flex items-center gap-2 text-rose font-bold tracking-widest text-xs mb-3" data-id="element-243">
            ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
          </div>
          <div className="flex items-center justify-center gap-2" data-id="element-244">
            {[{
            v: h,
            l: 'HS'
          }, {
            v: m,
            l: 'MIN'
          }, {
            v: sec,
            l: 'SEG'
          }].map((t, i) => <Fragment key={i} data-id="element-245">
                <div className="bg-ink text-white rounded-2xl px-4 py-3 min-w-[70px] md:min-w-[80px]" data-id="element-246">
                  <div className="font-serif text-3xl md:text-4xl font-bold leading-none" data-id="element-247">
                    {t.v}
                  </div>
                  <div className="text-[10px] tracking-widest text-white/60 mt-1" data-id="element-248">
                    {t.l}
                  </div>
                </div>
                {i < 2 && <span className="text-rose text-2xl font-bold" data-id="element-249">:</span>}
              </Fragment>)}
          </div>
          <p className="text-sm text-muted mt-3" data-id="element-250">⚠️ Después sube. No vuelve.</p>
        </motion.div>

        {/* Stock indicator */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="bg-white border border-line rounded-2xl p-4 mb-8" data-id="element-251">
          <div className="flex items-center justify-between mb-2 text-sm font-semibold text-ink" data-id="element-252">
            <span className="flex items-center gap-2" data-id="element-253">
              <span className="w-2 h-2 rounded-full bg-rose animate-pulse" data-id="element-254" />{' '}
              Cupos al precio actual
            </span>
            <span className="text-rose" data-id="element-255">72%</span>
          </div>
          <div className="h-2 bg-bg-warm rounded-full overflow-hidden" data-id="element-256">
            <div className="h-full bg-rose rounded-full" style={{
            width: '72%'
          }} data-id="element-257" />
          </div>
          <p className="text-xs text-muted mt-2" data-id="element-258">
            72% de los cupos ya fueron tomados
          </p>
        </motion.div>

        {/* Offer card */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="relative bg-white border border-rose/30 rounded-3xl p-7 md:p-10 shadow-2xl shadow-rose/10" data-id="element-259">
          <div className="text-center mb-6" data-id="element-260">
            <div className="inline-flex items-center gap-2 bg-rose-bg text-rose px-3 py-1 rounded-full mb-4" data-id="element-261">
              <span className="text-[11px] font-bold tracking-widest" data-id="element-262">
                ⭐ OFERTA ESPECIAL
              </span>
            </div>
            <h2 className="font-serif font-bold text-3xl md:text-4xl text-ink uppercase tracking-tight leading-tight" data-id="element-263">
              Cómo Trabajar con{' '}
              <span className="font-serif-italic text-rose font-normal normal-case" data-id="element-264">
                Gente Complicada
              </span>
            </h2>
            <p className="font-serif-italic text-rose text-lg mt-2" data-id="element-265">
              6 Módulos + 5 Bonus
            </p>
          </div>

          {/* Price */}
          <div className="text-center mb-7" data-id="element-266">
            <div className="text-muted line-through text-xl mb-1" data-id="element-267">$39.980</div>
            <div className="flex items-baseline justify-center gap-2 flex-wrap" data-id="element-268">
              <span className="font-serif font-bold text-5xl md:text-6xl text-rose" data-id="element-269">
                $19.990
              </span>
              <span className="text-lg text-ink-soft" data-id="element-270">ARS</span>
            </div>
            <div className="text-sm text-muted mt-2" data-id="element-271">
              Pago único · Acceso de por vida
            </div>
          </div>

          {/* Includes */}
          <div className="bg-bg-warm border border-line rounded-2xl p-5 md:p-6 mb-7" data-id="element-272">
            <div className="text-xs font-bold text-rose tracking-widest mb-4 text-center" data-id="element-273">
              INCLUYE TODO ESTO
            </div>
            <ul className="space-y-2.5" data-id="element-274">
              {includes.map((it, i) => <li key={i} className="flex items-start gap-3 text-sm" data-id="element-275">
                  <span className="flex-shrink-0 w-5 h-5 rounded-full bg-rose/15 flex items-center justify-center mt-0.5" data-id="element-276">
                    <CheckIcon className="w-3 h-3 text-rose" strokeWidth={3} data-id="element-277" />
                  </span>
                  <span className="text-ink" data-id="element-278">{it}</span>
                </li>)}
            </ul>
          </div>

          <a href="#" className="flex items-center justify-center gap-2 w-full bg-rose hover:bg-rose-deep text-white font-bold text-lg md:text-xl py-5 rounded-full text-center shadow-xl shadow-rose/30 hover:-translate-y-0.5 transition-all" data-id="element-279">
            <ArrowRightIcon className="w-5 h-5" data-id="element-280" />
            QUIERO MI ACCESO AHORA
          </a>

          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 mt-6 text-xs text-muted" data-id="element-281">
            <span className="flex items-center gap-1.5" data-id="element-282">
              <LockIcon className="w-3.5 h-3.5 text-rose" data-id="element-283" /> Pago seguro
            </span>
            <span className="text-line" data-id="element-284">|</span>
            <span className="flex items-center gap-1.5" data-id="element-285">
              <ZapIcon className="w-3.5 h-3.5 text-rose" data-id="element-286" /> Acceso en 5 min
            </span>
            <span className="text-line" data-id="element-287">|</span>
            <span className="flex items-center gap-1.5" data-id="element-288">
              <ShieldCheckIcon className="w-3.5 h-3.5 text-rose" data-id="element-289" /> Garantía 7
              días
            </span>
            <span className="text-line" data-id="element-290">|</span>
            <span className="flex items-center gap-1.5" data-id="element-291">
              <CreditCardIcon className="w-3.5 h-3.5 text-rose" data-id="element-292" /> Mercado Pago
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}